import styled from "styled-components/macro";
import { themeVariables } from "../../themeVariables";

export const RelativeContainer = styled.div`
  position: relative;
`;

export const DropdownContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: row;
  border: 1px solid ${themeVariables.grey3};
  border-radius: 10px;
  box-shadow: ${themeVariables.tinyDropShadow};
  max-width: 250px;
  min-width: 50px;
  overflow: hidden;
  cursor: pointer;

  &.disabled {
    opacity: 0.5;

    .disabled {
      opacity: 1;
    }
  }

  &:hover {
    background-color: ${themeVariables.menuColorHover};
    transition: background-color 0.3s ease-in-out;
  }

  &:active {
    background-color: ${themeVariables.menuColorActive};
  }

  .label-wrapper,
  .icon-button-wrapper {
    display: flex;

    &.icon-button-wrapper {
      width: auto;

      .icon-wrapper {
        height: auto;
        width: auto;
        padding: 11px 9px 10px;

        svg {
          width: 14px;
          height: 14px;

          path {
            fill: ${themeVariables.grey2};
          }
        }

        &:hover {
          background-color: transparent;
        }
      }
    }

    &.label-wrapper {
      flex: 1;
      overflow: hidden;
    }

    .label-inner,
    .icon-wrapper {
      padding: 7px 7px 7px 10px;
      color: ${themeVariables.grey0};
      font-weight: 500;
      font-size: 16px;
      line-height: 1.6em;
      font-family: Inter, sans-serif;

      svg {
        path {
          fill: var(--primary-cta);
        }
      }
    }

    .icon-button-wrapper {
      flex-shrink: 0;
    }

    .label-inner {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 100%;
    }
  }
`;

export const OptionsContainer = styled.ul`
  position: absolute;
  top: 51px;
  right: 0;
  list-style: none;
  background-color: var(--menu-color);
  border-radius: 10px;
  z-index: 3000;
  overflow: hidden auto;
  max-height: calc(-205px + 100vh);
  max-width: 385px;
  transition: all 0.3s ease-out;
  scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.15), 0px 0px 15px 0px rgba(0, 0, 0, 0.15);
  min-width: max-content;
  width: max-content;

  li.option-item {
    margin: 5px;
    max-width: 385px;
    user-select: none;

    &:first-child {
      margin-top: 5px;
    }

    &:last-child {
      margin-bottom: 5px;
    }

    button.option-item-button {
      outline: none;
      border: none;
      color: var(--grey-0);
      padding: 8px 10px !important;
      font-family: "Inter", sans-serif;
      font-size: 16px;
      font-weight: 500;
      line-height: 1.3;
      background-color: transparent !important;
      width: 100%;
      text-align: left;
      border-radius: 10px !important;
      display: flex;
      align-items: center;
      gap: 8px;

      svg {
        width: 24px;
        height: 24px;
      }

      &:hover,
      &.selected {
        background-color: var(--menu-color-hover) !important;
        cursor: pointer;
      }

      &:active {
        background-color: ${themeVariables.menuColorActive} !important;
      }

      &.danger {
        color: ${themeVariables.dangerColor} !important;

        &:hover,
        &.selected {
          background-color: ${themeVariables.dangerColorHover} !important;
        }

        &:active {
          background-color: ${themeVariables.dangerColorActive} !important;
        }

        svg {
          path {
            fill: ${themeVariables.dangerColor};
          }
        }
      }

      p {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        &.danger {
          color: ${themeVariables.dangerColor};
        }
      }
    }
  }
`;
